import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import { DefaultDashboardSectionsState, DashboardSectionsState } from "../state/stateItems";
import { TDashboardSectionItem } from "@/data/types";
import { getAllDashboardSectionsAsync, getDashboardSectionByIdAsync } from "../actions";

const handleGetAllDashboardSectionsAsync = (
  state: DashboardSectionsState,
  action: PayloadAction<{ items: TDashboardSectionItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.items = items;
};

const handleGetDashboardSectionByIdAsync = (
  state: DashboardSectionsState,
  action: PayloadAction<TDashboardSectionItem>
) => {
  if (!action?.payload) {
    return state;
  }

  const dashboardSection = action.payload;

  state.currentDashboardSection = dashboardSection;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<DashboardSectionsState>) => {
  builder.addCase(getAllDashboardSectionsAsync.fulfilled.type, handleGetAllDashboardSectionsAsync);
  builder.addCase(getDashboardSectionByIdAsync.fulfilled.type, handleGetDashboardSectionByIdAsync);
};

export default createReducer(DefaultDashboardSectionsState, reducerBuilder);